import _ from 'lodash';
import { AT } from '../../actions/actionTypes';
import * as Devices from './model';
import { PREFIX as DEVICE_PREFIX } from './actiontypes';
import DTReducer from '../datatable/reducer';
import { resetState } from '../datatable/utils';
import { StateDefault } from './defaults';
import Logger from '../../libs/logger';   import { LogArea } from '../../libs/logger/const';

const mapActionType = (actionType: string): string =>
  _.values(AT.DEVICES).indexOf(actionType) !== -1
    ? _.replace(actionType, DEVICE_PREFIX, '')
    : '';

export default function (state = StateDefault, action: any): Devices.State {
  const dtActionType = { ...action, type: mapActionType(action.type) };
  // Logger.info(["Transform Actions", dtActionType, action], Logger.LogArea.Redux);
  const stateAfterDT: Devices.State = {
    ...state,
    ...DTReducer(state, dtActionType),
  };

  switch (action.type) {
    case AT.DEVICES.SEARCH_SUCCESS: {
      Logger.info(
        [AT.DEVICES.SEARCH_SUCCESS, action, stateAfterDT],
        LogArea.Redux
      );
      const { totalsByType }: Devices.SearchPageSuccessPL = action.payload;
      const data = { ...stateAfterDT.data, totalsByType };
      return { ...stateAfterDT, data };
    }

    case AT.DEVICES.FILTER_CRITERIA_UPADATED: {
      Logger.info(
        [AT.DEVICES.FILTER_CRITERIA_UPADATED, action],
        LogArea.Redux
      );
      const filters: Devices.FilterCritria = action.payload;
      return { ...stateAfterDT, ...resetState(stateAfterDT), filters };
    }

    case AT.DEVICES.TABLE_COLUMNS: {
      Logger.info([AT.DEVICES.TABLE_COLUMNS, action], LogArea.Redux);
      const table = { ...stateAfterDT.table, columns: action.payload };
      return { ...stateAfterDT, table };
    }

    case AT.DEVICES.REMOVE_FETCH: {
      Logger.info([AT.DEVICES.REMOVE_FETCH, action], LogArea.Redux);
      const actionStatus = { ...stateAfterDT.actionStatus, isDeactiving: true };
      return { ...stateAfterDT, actionStatus };
    }

    case AT.DEVICES.REMOVE_SUCCESS: {
      Logger.info([AT.DEVICES.REMOVE_SUCCESS, action], LogArea.Redux);
      const state = resetState(stateAfterDT);
      const actionStatus = {
        ...stateAfterDT.actionStatus,
        isDeactiving: false,
      };
      return { ...stateAfterDT, ...state, actionStatus };
    }

    case AT.DEVICES.REMOVE_ERROR: {
      Logger.info([AT.DEVICES.REMOVE_ERROR, action], LogArea.Redux);
      const actionStatus = {
        ...stateAfterDT.actionStatus,
        isDeactiving: false,
      };
      return { ...stateAfterDT, actionStatus };
    }

    case AT.DEVICES.ACTIVATE_FETCH: {
      Logger.info([AT.DEVICES.ACTIVATE_FETCH, action], LogArea.Redux);
      const actionStatus = { ...stateAfterDT.actionStatus, isActivating: true };
      return { ...stateAfterDT, actionStatus };
    }

    case AT.DEVICES.ACTIVATE_SUCCESS: {
      Logger.info([AT.DEVICES.ACTIVATE_SUCCESS, action], LogArea.Redux);
      const state = resetState(stateAfterDT);
      const actionStatus = {
        ...stateAfterDT.actionStatus,
        isActivating: false,
      };
      return { ...stateAfterDT, ...state, actionStatus };
    }

    case AT.DEVICES.ACTIVATE_ERROR: {
      Logger.info([AT.DEVICES.ACTIVATE_ERROR, action], LogArea.Redux);
      const actionStatus = {
        ...stateAfterDT.actionStatus,
        isActivating: false,
      };
      return { ...stateAfterDT, actionStatus };
    }

    case AT.DEVICES.SEARCHVF_SUCCESS:
      Logger.info(
        [AT.DEVICES.SEARCHVF_SUCCESS, action, stateAfterDT],
        LogArea.Redux
      );
      const filters: Devices.FilterCritria = { ...stateAfterDT.filters };
      filters.serialNumber = action.payload;
      return { ...stateAfterDT, filters };

    case AT.DIALOG_READRIGHTS_REMOVE_SUCCESS:
    case AT.DIALOG_READRIGHTS_ASSIGN_SUCCESS:
    case AT.DEVICES.RESET:
      Logger.info([AT.DEVICES.RESET], LogArea.Redux);
      return { ...stateAfterDT, ...resetState(stateAfterDT) };

    default: {
      return stateAfterDT;
    }
  }
}
